import { useState, useEffect } from 'react';
import api from '@/services/api';

const cpnCache = {};

export function useCPN(mpn) {
  const [cpn, setCpn] = useState(cpnCache[mpn] || null);

  useEffect(() => {
    if (!mpn) return;
    if (cpnCache[mpn] !== undefined) {
      setCpn(cpnCache[mpn]);
      return;
    }
    let cancelled = false;
    api.get(`/v1/my-items/cpn/${encodeURIComponent(mpn)}`)
      .then(res => {
        if (!cancelled) {
          const val = res.data?.cpn || null;
          cpnCache[mpn] = val;
          setCpn(val);
        }
      })
      .catch(() => {
        if (!cancelled) {
          cpnCache[mpn] = null;
          setCpn(null);
        }
      });
    return () => { cancelled = true; };
  }, [mpn]);

  return cpn;
}

export function CPNBadge({ mpn, className = '' }) {
  const cpn = useCPN(mpn);
  if (!cpn) return null;
  return (
    <span className={`text-xs text-purple-700 bg-purple-50 border border-purple-200 px-1.5 py-0.5 rounded font-medium ${className}`}
      data-testid={`cpn-badge-${mpn}`}>
      CPN: {cpn}
    </span>
  );
}
